import { jsx } from "react/jsx-runtime";
import InvertColorsIcon from "@mui/icons-material/InvertColors";
import { validateTidalLicense } from "../../base/index.js";
function InvertColors(props) {
  return /* @__PURE__ */ jsx(
    InvertColorsIcon,
    {
      "data-testid": "InvertColors",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "InvertColors",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
InvertColors.tidalIconMeta = {
  categories: "miscellaneous",
  name: "InvertColors"
};
validateTidalLicense();
export {
  InvertColors
};
//# sourceMappingURL=InvertColors.js.map
